import React from 'react';
import {connect} from 'react-redux';
import Icon from "../../../../../../../../components/icon";
import {dropDownPosition} from '../../../../../../../../utils';
import './index.css';

class AutoCompletion extends React.Component {

	componentDidMount(){
		if(document.querySelector('.auto-complete')){
			dropDownPosition(
				document.querySelector('.auto-complete').previousSibling,
				document.querySelector('.auto-complete').previousSibling.children[0].children[0],
				document.querySelector('.auto-complete')
			);
		}

	}

	render() {

        const collabAutoCompleteList = (result) => {
            if(result.name){
                if(result.emails){
                    return result.name + ' (' + result.emails.join(', ') + ')';
                } else {
                    return result.name + ' (' + result.email + ')';
                }

            } else {
                if(result.emails){
                    return result.emails.join(', ');
                } else {
                    return result.email;
                }
            }
        };

		if (this.props.autoComplete.length > 0) {

			let results = this.props.autoComplete.filter( acItem => {
				return !this.props.addedCollaborators.some( addedCollaborator => {
					return acItem.email === addedCollaborator.email
				});
			});

			return (
				<div className={`auto-complete`}>
					{
						results.map( (result, index) => (
							<div
								className={`d-flex align-items-center js-result${this.props.selectedCollaboratorIndex === index ? ' active' : ''}`}
								key={result.id || result.email || index}
								onClick={this.props.addCollaboratorClickHandler}
								id={result.id || result.email}
							>
								{
									result.type === 'group'
										?
										<Icon className="mr-2" name={'group'}/>
										:
										<Icon className="mr-2" name={'user'}/>
								}
								<p>
									{
										collabAutoCompleteList(result)
                                    }
								</p>
							</div>
						))
					}
				</div>
			);
		} else if(this.props.autoCompleteLoading) {
			return (
				<div className={`auto-complete`}>
					<div className="text-center">
						<Icon name="spinner"/>
					</div>
				</div>
			);
		} else {
			return null;
		}


	}
}

const mapStateToProps = (state) => {
	return {
		addedCollaborators : state.sharingDetailsReducer.getAddedCollaborators,
		autoCompleteLoading : state.sharingDetailsReducer.autoCompleteLoading,
		autoComplete : state.sharingDetailsReducer.getAutoComplete,
		selectedCollaboratorIndex: state.addCollaboratorDetailsReducer.selectedCollaboratorIndex,
	};
};

export default connect(mapStateToProps)(AutoCompletion);